import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const LANGS = [
  { code: "fr", label: "Français", cc: "fr" },
  { code: "en", label: "English (UK)", cc: "gb" },
  { code: "nl", label: "Nederlands (BE)", cc: "be" },
];

const Flag = ({ cc, className = "" }) => (
  <img src={`https://flagcdn.com/${cc}.svg`} alt={cc}
    className={`inline-block h-3.5 w-5 rounded-[3px] object-cover shadow-sm ${className}`} loading="lazy" />
);

export function LanguageSwitcher({ variant = "dark" }) {
  const { i18n } = useTranslation();
  const current = LANGS.find((l) => i18n.language?.startsWith(l.code)) || LANGS[0];
  const base = variant === "light"
    ? "text-white/90 hover:bg-white/15 border-white/20"
    : variant === "onlight"
    ? "text-slate-700 hover:bg-slate-100 border-slate-200"
    : "text-foreground/80 hover:bg-white/5 border-white/10";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher"
        className={`inline-flex items-center gap-2 rounded-full px-3 h-9 text-sm font-semibold border transition ${base}`}>
        <Globe className="h-4 w-4" /> <Flag cc={current.cc} />
        <span className="hidden sm:inline">{current.code.toUpperCase()}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.code} data-testid={`lang-${l.code}`} onClick={() => i18n.changeLanguage(l.code)}
            className={i18n.language?.startsWith(l.code) ? "font-semibold text-sky-500" : ""}>
            <Flag cc={l.cc} className="mr-2" /> {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
